/**
 * Game stage enum.
 */
export enum GameStage {
  LoggedOut,
  RoomChoosing,
  InRoom,
  InvitationSent,
  GameConfirmation,
  GameInProgress,
  GameContinueConfirm,
  BeforeWatch,
}
